import React, { useContext } from "react";
import { DrawModeChangeEvent } from "@mapbox/mapbox-gl-draw";
import { RemoveRoad } from "@mui/icons-material";

import { MapContext } from "../MapProvider";

import { IButtonProps } from "./Toolbar";
import ToolbarToggleButton from "./ToolbarToggleButton";
import { useLayerEditable } from "./useLayerEditable";

const SnapDeleteButton: React.FC<IButtonProps> = ({ icon, title = "Delete path" }) => {
  const { map, drawControl } = useContext(MapContext);
  const isLayerEditable = useLayerEditable();

  const handleOnClick = () => {
    if (!drawControl.current) return;
    drawControl.current.changeMode("snap_delete_feature");
    map?.fire("draw.modechange", { type: "draw.modechange", mode: "snap_delete_feature" } as unknown as DrawModeChangeEvent);
  };

  return (
    <ToolbarToggleButton
      title={title}
      value="snap_delete_feature"
      onClick={handleOnClick}
      data-testid="toolbar-snap-delete-button"
      disabled={!isLayerEditable}
    >
      {icon || <RemoveRoad />}
    </ToolbarToggleButton>
  );
};

export default SnapDeleteButton;
